module.exports = __webpack_public_path__ + "static/media/gal-1.405e35fe.jpeg";